// extracted by mini-css-extract-plugin
export default {"wrapper":"Styles_wrapper__tLtNQ","section":"Styles_section__ekzVU"};